import Vue from 'vue';
import VuePluralize from 'vue-pluralize';

Vue.use(VuePluralize);
